module.exports = __webpack_public_path__ + "static/media/remove-red.3b95b27e.svg";